import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import { Accordion, Row, Card } from "react-bootstrap"
import { IoMdArrowDropdown } from "react-icons/io"

const FaqComp = () => {
  const query = graphql`
    {
      allStrapiFaqs(filter: { category: { eq: "For GUARANTORS" } }) {
        nodes {
          id
          category
          question
          answer
        }
      }
    }
  `

  const data = useStaticQuery(query)

  const {
    allStrapiFaqs: { nodes },
  } = data

  return (
    <Row className="p-fix">
      <Accordion
        className="my-4"
        defaultActiveKey="0"
        style={{ cursor: "pointer" }}
      >
        {nodes.map((faq, index) => {
          return (
            <Card key={index}>
              <Accordion.Toggle
                as={Card.Header}
                eventKey={index + 1}
                className="d-flex align-items-center justify-content-between"
              >
                <h6 className="rb">{faq.question}</h6>
                <IoMdArrowDropdown />
              </Accordion.Toggle>
              <Accordion.Collapse eventKey={index + 1}>
                <Card.Body>
                  <p>{faq.answer}</p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          )
        })}
      </Accordion>
    </Row>
  )
}

export default FaqComp
